const fiMessages = {
  /* 01.General */
 "main.name": "Nimi",
  "main.sentiment": "Tunne",
  "main.urgency": "Kiireellisyys",
  "main.language": "Kieli",
  "main.agent": "Agentti",
  "main.property_name": "Kohteen nimi",
  "main.booking_number": "Varausnumero",
  "main.check_out": "Uloskirjautuminen",
  "main.check_in": "Sisäänkirjautuminen",
  "main.adults": "Aikuiset",
  "main.corporate_code": "Yrityskoodi",
  "main.group_code": "Ryhmäkoodi",
  "main.promo_code": "Alennuskoodi",
  "main.ai_response": "Tekoälyn vastaus",
  "main.template_response": "Mallivastaus",
  "main.converttoticket": "Muunna tiketiksi",
  "main.switch_property": "Vaihda kohdetta",
  "main.Group_id": "Ryhmän tunnus",
  "main.integration_id": "Integraation tunnus",
  "main.submit": "Lähetä",
  "main.cancel": "Peruuta",
    "main.select_template": "Valitse malli",
  "main.rooms": "Huoneet",
  "main.rates": "Hinnat",

  //footer
    "footer.knowledge": "Tietämys",
  "footer.home": "Koti",
  "footer.help": "Ohje",

  //ticket
  "ticket.thank_you": "Kiitos lomakkeen lähettämisestä",
  "ticket.ticket": "Tiketti",
  "ticket.details": "Täytä lomake ja kuvaile tiketin tiedot.",
  "ticket.select_category": "Valitse luokka",
  "ticket.category": "Luokka",
  "ticket.title": "Otsikko",
  "ticket.notes": "Muistiinpanot",
  "ticket.status": "Tila",
  "ticket.assigned_to": "Määritetty henkilölle",
  "ticket.submit_form": "Lähetä lomake",


  "main.total": "Yhteensä",
  "main.pastetooutlook": "Liitä Outlookiin",
  "main.children": "Lapset",
  "main.promocode": "Promo-/yritys-/ryhmäkoodi",
  "main.exact_match_only": "Vain tarkka vastaavuus",
  "main.search": "Haku",
  "main.no_rate_match": "Valintaasi vastaavia hintoja ei löytynyt. Muokkaa hakua ja yritä uudelleen.",
  "main.translate_to": "Käännä kohteeseen",
  "main.regenerate": "Luo uudelleen",
  "main.copy_text": "Kopioi teksti",
  "main.additional_instructions": "Lisäohjeet",

  "faq.helpcenter": "Ohjekeskus",
  "faq.reply.email.sabre.question": "Kuinka vastaan sähköpostiin käyttämällä Aven Hospitality Concierge Email Automationia?",
  "faq.reply.email.sabre.answer": "Avaa sähköposti ja käynnistä Aven Hospitality -lisäosa. Voit valita kolmesta vaihtoehdosta: käyttää valmista mallia, luoda tekoälyvastauksen tai muuntaa sähköpostin tiketik­si. Valitse kyselyyn sopivin vaihtoehto, tarkista vastaus, tee tarvittavat muutokset ja lähetä se suoraan Outlookista.",

  "faq.rates.availability.question": "Kuinka lisään hinnat, saatavuuden ja huonetiedot vastaukseeni?",
  "faq.rates.availability.answer": "Käytä + Rates -toimintoa syöttääksesi vierastiedot, kuten päivämäärät ja vieraiden määrän. Concierge lisää oikean saatavuuden ja hinnoittelun vastaukseesi. Voit myös käyttää + Rooms -toimintoa huonekuvausten ja kuvien lisäämiseen.",

  "faq.different.language.question": "Mitä teen, jos sähköposti on eri kielellä?",
  "faq.different.language.answer": "Aven Hospitality Concierge mahdollistaa saapuvien sähköpostien kääntämisen haluamallesi kielelle.",

  "faq.pin.addin.question": "Kuinka varmistan, että lisäosa on aina saatavilla Outlookissa?",
  "faq.pin.addin.answer": "Kiinnitä Aven Hospitality Concierge -lisäosa Outlookiin, jotta se avautuu automaattisesti jokaisen sähköpostin yhteydessä.",

  "faq.knowledge.hub.question": "Mikä on Knowledge Hub -hakutoiminto?",
  "faq.knowledge.hub.answer": "Knowledge Hub -haku auttaa löytämään nopeasti kohdekohtaisia tietoja Outlookissa.",

  "faq.reply.email.myma.question": "Kuinka vastaan sähköpostiin käyttämällä Mymaa?",
  "faq.reply.email.myma.answer": "Avaa sähköposti ja käynnistä Myma-lisäosa. Voit käyttää mallia, luoda tekoälyvastauksen tai muuntaa sähköpostin tiketiksi.",

  "faq.room.details.question": "Kuinka lisään huonetiedot vastaukseeni?",
  "faq.room.details.answer": "Käytä + Rooms -toimintoa huonekuvausten ja kuvien lisäämiseen.",

  "faq.myma.different.language.question": "Mitä teen, jos sähköposti on eri kielellä?",
  "faq.myma.different.language.answer": "Myma mahdollistaa saapuvien sähköpostien kääntämisen haluamallesi kielelle.",

  "faq.myma.pin.addin.question": "Kuinka varmistan, että lisäosa on aina saatavilla Outlookissa?",
  "faq.myma.pin.addin.answer": "Kiinnitä Myma-lisäosa Outlookiin, jotta se avautuu automaattisesti jokaisen sähköpostin yhteydessä."

};

export default fiMessages;